// openRecommendDiamondPackSelector.js
'use strict';
import { MERGE_OPERATION_DATA, SET_LIST_ITEMS } from '../ActionTypes.js';
import addvalue from '../action/addvalue.js';
import { SHOP_ID } from '../resource/shopConstants.js';

/**
 * Open specified diamond pack selector
 * @kind action
 * @param {array} {[productIds = []]} - product ids.
 * @param {array} {[categories = []]} - product categories.
 * @param {string} {via} - where open specified diamond pack selector.
 * @param {string} {currency} - currency.
 * @param {string} {recommendProductId} - recommend product id.
 * @return {Promise} Action promise.
 */
const openRecommendDiamondPackSelector =
  ({ productIds = [], categories = [], currency, via, recommendProductId }) =>
  async dispatch => {
    if (productIds.length === 0 && categories.length === 0) {
      return dispatch(addvalue({ shopId: SHOP_ID.addvalue, via }));
    }
    dispatch({
      type: MERGE_OPERATION_DATA,
      payload: {
        selectPath: ['shop'],
        data: {
          currency,
        },
      },
    });
    dispatch({
      type: MERGE_OPERATION_DATA,
      payload: {
        selectPath: ['shop', SHOP_ID.addvalue],
        data: {
          recommendProductId,
          categories,
        },
      },
    });
    dispatch({
      type: SET_LIST_ITEMS,
      payload: {
        selectPath: ['shop', SHOP_ID.addvalue, 'products'],
        itemIds: productIds,
        totalCount: productIds.length,
      },
    });
    return dispatch(addvalue({ shopId: SHOP_ID.addvalue, via }));
  };

export default openRecommendDiamondPackSelector;
